import { AppBrands } from 'src/utils/constants';
import CONFIG from 'src/utils/config';
import KnowledgeInfoBrekr from './KnowledgeInfoBrekr';
import KnowledgeInfo from './KnowledgeInfo';

const KnowledgeInfoPage = () => {
    const { APP_BRAND } = CONFIG;

    if (APP_BRAND === AppBrands.BREKR) {
        return <KnowledgeInfoBrekr />;
    }

    return <KnowledgeInfo />;
};

export default KnowledgeInfoPage;
